export default __webpack_public_path__ + "static/media/kitchen2.4d6f80ba.jpg";